import Card from 'scripts/models/api/cards/base/card';
import EmbedHtml from 'scripts/models/api/embed/html';

export default  Card.extend({
    define: {
        network: {
            type: 'string',
            value: ''
        },
        postUrl: {
            type: 'string',
            value: ''
        },
        embed: {
            Type: EmbedHtml,
            Value: '*'
        }
    }
});